import {useQuery} from '@tanstack/react-query'
import {getUserStatuses} from '../../api/userStatuses'
import {queryKeys} from '../../constants/queryKey'

function useGetUserStatusesQuery() {
  return useQuery<any>([queryKeys.userStatuses], () => getUserStatuses(), {})
}

export default useGetUserStatusesQuery
